const css = `.routine-alert {
  margin-bottom: 16px;
}
.routine-alert .routine-alert-link {
  color: var(--danger);
  text-decoration: underline;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvUm91dGluZUFsZXJ0Iiwic291cmNlcyI6WyJSb3V0aW5lQWxlcnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOztBQUVBO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5yb3V0aW5lLWFsZXJ0IHtcbiAgbWFyZ2luLWJvdHRvbTogMTZweDtcblxuICAucm91dGluZS1hbGVydC1saW5rIHtcbiAgICBjb2xvcjogdmFyKC0tZGFuZ2VyKTtcbiAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
